import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { useReducer } from 'react';
export var ACTION_CLEAR = 'CLEAR';
export var ACTION_LOADING = 'LOADING';
export var ACTION_SUCCESS = 'SUCCESS';
export var ACTION_ERRORED = 'ERROR';
export var INITIAL_STATE = {
  items: null,
  error: null,
  isLoading: false
};
export function reducer(state, action) {
  switch (action.type) {
    case ACTION_CLEAR:
      return _objectSpread({}, INITIAL_STATE);
    case ACTION_LOADING:
      return _objectSpread(_objectSpread({}, INITIAL_STATE), {}, {
        isLoading: true
      });
    case ACTION_SUCCESS:
      return _objectSpread(_objectSpread(_objectSpread({}, state), action.payload), {}, {
        error: null
      });
    case ACTION_ERRORED:
      return _objectSpread(_objectSpread({}, INITIAL_STATE), {}, {
        error: action.payload
      });
    default:
      return state;
  }
}
export var usePluginReducer = function usePluginReducer() {
  return useReducer(reducer, INITIAL_STATE);
};